import { createSlice } from '@reduxjs/toolkit';
import { getFromSessionStorage } from '../storage';
import { IColor, IIcon } from '../../interfaces';
import uniqueId from 'lodash-es/uniqueId';

export interface IFormState{
    icons: IIcon[],
    colors: IColor[],
    backgroundColor: IColor,
    backgroundColorEnabled: boolean,
}

export const formDefaults: IFormState = {
    icons: [],
    backgroundColor: { r: 0, g: 0, b: 0, a: 1, cid: uniqueId() },
    backgroundColorEnabled: true,
    colors: [
        { r: 166, g: 135, b: 159, a: 1, cid: uniqueId() },
        { r: 82, g: 230, b: 81, a: 1, cid: uniqueId() },
        { r: 133, g: 73, b: 231, a: 1, cid: uniqueId() },
        { r: 99, g: 157, b: 105, a: 1, cid: uniqueId() },
        { r: 228, g: 124, b: 36, a: 1, cid: uniqueId() },
        { r: 46, g: 107, b: 148, a: 1, cid: uniqueId() },
        { r: 91, g: 179, b: 147, a: 1, cid: uniqueId() },
        { r: 136, g: 214, b: 139, a: 1, cid: uniqueId() },
        { r: 130, g: 198, b: 198, a: 1, cid: uniqueId() },
        { r: 139, g: 97, b: 197, a: 1, cid: uniqueId() },
    ],
};

// try get data from session storage
const savedData = getFromSessionStorage();

/**
 * initial state
 */
const initialState: IFormState = {
    icons: [],
    colors: savedData?.colors || formDefaults.colors,
    backgroundColor: savedData?.backgroundColor || formDefaults.backgroundColor,
    backgroundColorEnabled: (!savedData || savedData?.backgroundColorEnabled === undefined) ? formDefaults.backgroundColorEnabled : savedData?.backgroundColorEnabled,
};

const formSlice = createSlice({
    name: 'form',
    initialState,
    reducers: {

        main(state, action) {

            return {
                ...state,
                ...action.payload,
            };
        },
    }
});

export default formSlice;